document.addEventListener('DOMContentLoaded', () => {
  const accordionModules = document.querySelectorAll('.a-accordion-two-column')

  accordionModules.forEach((accordionModule) => {
    const accordion = accordionModule.querySelector('.accordion')
    const items = accordion.querySelectorAll('.accordion__item')

    items.forEach((item) => {
      let itemExpanded = false
      const header = item.querySelector('.item__header')
      const body = item.querySelector('.item__body')

      header.addEventListener('click', () => {
        if (itemExpanded) {
          item.classList.remove('expanded')
          body.style.maxHeight = 0 + 'px'
        } else {
          item.classList.add('expanded')
          body.style.maxHeight = body.scrollHeight + 'px'
        }
        itemExpanded = !itemExpanded
      })
      window.addEventListener('resize', () => {
        if (itemExpanded) {
          body.style.maxHeight = body.scrollHeight + 'px'
        } else {
          body.style.maxHeight = 0 + 'px'
        }
      })
    })
  })
})
